module.exports = __webpack_public_path__ + "assets/production.6336a95c.svg";